import requestDemo from './b4-request-demo.vue';
var formComponents = {
    requestDemo: requestDemo
};
export { formComponents };
